import DataTable from 'components/ui/DataTable/data-table';
import 'css/style.css';
import { FC, useState } from 'react';
import { ITrainingInput, useListTrainingQuery } from 'redux/reducers/training';
import DeleteIcon from '../../../../assets/images/icons/delete.png';
import EditIcon from '../../../../assets/images/icons/edit.png';
interface ITraineeDataTable {
  onEditClicked: (data: ITrainingInput) => void;
  onDeleteClicked: (data: ITrainingInput) => void;
  onAddResourceClicked: (data: ITrainingInput) => void;

  searchQuery: string;
}
const TrainingManagementTable: FC<ITraineeDataTable> = ({
  onEditClicked,
  onDeleteClicked,
  onAddResourceClicked,
  searchQuery
}) => {
  const [pageNo, setPage] = useState(1);
  const pageSize = 10;
  const [allDataList, setAllDataList] = useState(0);
  const { data: trainingRes, isLoading } = useListTrainingQuery({ searchQuery });
  const totalTraining = trainingRes?.data || [];
 const totalRows = trainingRes?.data && trainingRes?.data.length > 0 ? trainingRes?.data?.[0].row_total : 0;

  const totalPages = Math.ceil(totalRows / 10);
  const canNext = pageNo < totalPages;
  const canPrevious = pageNo > 1;

  // const columns: any = [
  //   {
  //     Header: 'S.N',
  //     Cell: (data: any) => <>{(page - 1) * pageSize + data.row.index + 1}</>
  //   },
  //   {
  //     Header: 'Training Name',
  //     accessor: 'training_name'
  //   },
  //   {
  //     Header: 'Course',
  //     accessor: (
  //       row: Omit<ITrainingInput, 'courses'> & { courses: { id: number; title: string }[] }
  //     ) => row.courses.map((c) => c.title).join(', '),
  //     Cell: (
  //       cell: Cell<Omit<ITrainingInput, 'courses'> & { courses: { id: number; title: string }[] }>
  //     ) => {
  //       return (
  //         <div className="d-flex flex-wrap">
  //           {cell.row.original.courses.map((c) => (
  //             <span className="badge bg-info me-1">{c.title}</span>
  //           ))}
  //         </div>
  //       );
  //     }
  //   },
  //   {
  //     Header: 'Training Code',
  //     accessor: 'training_code'
  //   },
  //   {
  //     Header: 'Action',
  //     Cell: (data: Cell<ITrainingInput & { id: number }>) => {
  //       return (
  //         <>
  //           <img
  //             src={EditIcon}
  //             className="icons"
  //             onClick={() => onEditClicked(data.row.original)}
  //           />
  //           <img
  //             src={DeleteIcon}
  //             className="m-2 icons"
  //             onClick={() => onDeleteClicked(data.row.original)}
  //           />
  //         </>
  //       );
  //     }
  //   }
  // ];
  const columns = [
    {
      Header: 'S.N',
      Cell: (data: any) => <>{(pageNo - 1) * 10 + data.row.index + 1}</>
    },
    {
      Header: 'Training Name',
      accessor: 'training_name'
    },
    {
      Header: 'Training Code',
      accessor: 'training_code'
    },
           {
      Header: 'Publish',
      accessor: 'is_active',
        Cell: (data: any) => {
        return <>{data?.row?.values?.is_active ? "Yes":"No"}</>;
      }
    },
    {
      Header: 'Action',
      Cell: ({ row }: any) => (
        <>
          <img src={EditIcon} className="icons" onClick={() => onEditClicked(row.original)} />
          <img
            src={DeleteIcon}
            className="m-2 icons"
            onClick={() => onDeleteClicked(row.original)}
          />
          <button className="btn btn-primary" onClick={() => onAddResourceClicked(row.original)}>
            Resources
          </button>
        </>
      )
    }
  ];

  return (
    <DataTable
      columns={columns}
      data={totalTraining || []}
      isLoading={isLoading}
      pagination={{
        canPrevious,
        canNext,
        prevPage: () => {
            if (canPrevious) {
              setPage((prev) => prev - 1);

            }
          },
          nextPage: () => {
            if (canNext) {
              setPage((prev) => prev + 1);
            }
          }
      }}
      search={false}
    />
  );
};

export default TrainingManagementTable;
